// ==============================
//* PRODUCT PAGE VISUALS
//
//? This file manages the product page visuals elements.
// ==============================

const layout = require("./utils/layout");

$(() => {
    const $slider = $(".product-visuals__container.slider");
    const $sliderPager = $(".slick-pager");
    let resizeTimeout = false;

    /**
     * @return {boolean} Return true if the device is a mobile or a tablet
     */
    function isMobileDevice() {
        return layout.isMobile() || layout.isTablet();
    }

    /**
     * Resize Listener
     */
    $(window).on("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(initSlider, 300);
    });

    /**
     * Listener to update the Slider pager
     */
    $slider.on("init reInit afterChange", function (event, slick, currentSlide) {
        if (isMobileDevice()) {
            var i = (currentSlide ? currentSlide : 0) + 1;
            $sliderPager.text(i + "/" + slick.slideCount);
        }
    });

    /**
     * Slider initialization according to the device
     */
    function initSlider() {
        if ($slider.children().length > 1) {
            if (isMobileDevice() && !$slider.hasClass("slick-initialized")) {
                // Init the slider
                $slider.slick({
                    infinite: true,
                    slidesToShow: 1,
                    dots: true,
                    arrows: false
                });
            } else if (!isMobileDevice() && $slider.hasClass("slick-initialized")) {
                $slider.slick("unslick");
            }
        }
    }

    /**
     * Slider rebuilt
     */
    function rebuildSlider() {
        if ($slider.children().length > 1) {
            if (isMobileDevice() && $slider.hasClass("slick-initialized")) {
                $slider.slick("unslick");
                $slider.find("div[id^=\"slick-\"]").remove();

                $slider.slick({
                    infinite: true,
                    slidesToShow: 1,
                    dots: true,
                    arrows: false
                });
            }
        } else {
            $sliderPager.empty();
        }
    }

    const $sizeSelector = $(".select-size");

    const productVisualsReady = (callback) => {
        const sliderVisualsIntervalChecker = setInterval(() => {
            if ($(".product-visuals__container > .product-visuals__item").length) {
                clearInterval(sliderVisualsIntervalChecker);
                $(".product-visuals__container").css("visibility", "visible");
                callback();
            }
        }, 100);
    };

    $sizeSelector.on("change", () => {
        if (isMobileDevice()) {
            $(".product-visuals__container").css("visibility", "hidden");
            productVisualsReady(rebuildSlider);
        }
    });

    /**
     * Image Zoom Modal functionality
     */
    document.querySelectorAll(".js-zoom-toggle").forEach(button => {
        button.addEventListener("click", function () {
            const imageUrl = this.getAttribute("data-image-url");
            document.querySelector(".js-modal-image").setAttribute("src", imageUrl);
        });
    });

    initSlider();
});
